export default __webpack_public_path__ + "static/media/green_small.da83a41e.png";